import React, { memo } from 'react'
import { Currency } from '@pancakeswap/sdk'
import { useDexScreenerPrice } from 'hooks/useBUSDPrice'
import useTheme from 'hooks/useTheme'
import { Colors } from '@pancakeswap/uikit'

interface TokenPricePlainProps {
  currency: Currency
  amount: number
  chainId: number
  style?: React.CSSProperties
  color?: keyof Colors
  prefix?: string
  postfix?: string
}

const TokenPricePlain = memo(function TokenPriceDisplay({
  currency,
  amount,
  chainId,
  style = {},
  color,
  prefix = '~$',
  postfix = '',
}: TokenPricePlainProps) {
  const { price: amountInDollar, isLoading } = useDexScreenerPrice(
    currency,
    Number.isFinite(amount) ? amount : 0,
    chainId,
  )

  const { theme } = useTheme()
  const displayedColor = color ? theme.colors[color] : theme.colors.secondary

  if (!amountInDollar) return null

  if (isLoading) {
    return <span style={style}>...</span>
  }

  if (!Number.isFinite(amountInDollar)) {
    return null
  }

  const formattedPrice = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amountInDollar)

  return (
    <span style={{ ...style, color: displayedColor }}>
      {prefix}
      {formattedPrice}
      {postfix}
    </span>
  )
})

export default TokenPricePlain
